import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { generatePath, useHistory, useParams } from "react-router-dom";

import { LICENSE_REMOVED_MODAL_PATH } from "../../Roles/paths";
import { type RemoveLicenseModalRouteParams } from "../../Roles/types";
import { useArchiveLicense } from "../api/useArchiveLicense";
import { RemoveLicenseBottomSheet } from "./RemoveBottomSheet";

interface RemoveLicenseContainerProps {
  modalState: UseModalState;
  basePath: string;
}

export function RemoveLicenseContainer(props: RemoveLicenseContainerProps) {
  const { modalState, basePath } = props;

  const { userId: workerId } = useDefinedWorker();
  const { licenseId } = useParams<RemoveLicenseModalRouteParams>();
  const history = useHistory();

  const { mutateAsync: archiveLicense, isLoading: isRemovingLicense } = useArchiveLicense();

  return (
    <RemoveLicenseBottomSheet
      modalState={modalState}
      isRemovingLicense={isRemovingLicense}
      onRemoveLicense={async () => {
        await archiveLicense({ licenseId, workerId });
        history.replace(generatePath(`${basePath}/${LICENSE_REMOVED_MODAL_PATH}`, { licenseId }));
      }}
    />
  );
}
